import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyModule, type LazyComponent } from 'owa-bundling';
import { type TasksHubToggleButtonProps } from './components/TasksHubToggleButton.Props';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "CopilotChatTasksHub" */ './lazyIndex'),
    { name: 'CopilotChatTasksHub' }
);

export const LazyTasksHub: LazyComponent<{}, undefined> = createLazyComponent(
    lazyModule,
    m => m.TasksHub
);

export const LazyTasksHubToggleButton: LazyComponent<TasksHubToggleButtonProps, undefined> =
    createLazyComponent(lazyModule, m => m.TasksHubToggleButton);
